import sanitizeHtml from 'sanitize-html';

/**
 * @description given an html string - only allow for specific tags to be rendered
 * @param value string
 */
const sanitize = (
  value: string,
  options: Parameters<typeof sanitizeHtml>[1]
) => {
  const composedConfig = {
    allowedTags: ['b'],
    ...options,
  };
  return sanitizeHtml(value, composedConfig);
};

export default sanitize;
